import { Link } from '@tanstack/react-router';

/**
 * Несуществующий адрес. Отдельный экран, чтобы не путать его с отказом в доступе.
 *
 * Экран висит на корневом маршруте, вне оболочки: по битому адресу приходит
 * и тот, кто ещё не вошёл, а оболочка требует сессии. Значит, меню на странице
 * нет — и текст на него не ссылается. Выход из тупика даёт ссылка, а не совет
 * выбрать раздел (прогон QA 22.08.2026). Ссылка ведёт в защищённую область:
 * невошедшего она приведёт на форму входа, и это тоже возврат в приложение.
 */
export function NotFoundPage() {
  return (
    <section className="notice">
      <h1>Страница не найдена</h1>
      <p>Проверьте адрес: такого раздела в системе нет.</p>
      <p>
        <Link to="/">Вернуться на дашборд</Link>
      </p>
    </section>
  );
}
